import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '../../../config';
import { LoanDocumentEnum } from '../../../store/loanDocumentStore/enums/LoanDocumentEnum';
import { Component as LoanDocumentUploadPage } from '../LoanDocumentUploadPage/LoanDocumentUploadPage';

export function Component(): ReactNode {
  const { t } = useTranslation();

  return (
    <LoanDocumentUploadPage
      exampleDocumentUrl={config.loanDocuments.vsc.exampleDocumentUrl}
      subtitleText={t('LoanDocumentUploadVSCPage.subtitle')}
      titleText={t('LoanDocumentUploadVSCPage.title')}
      type={LoanDocumentEnum.SERVICE_CONTRACT}
    />
  );
}

Component.displayName = 'LoanDocumentUploadVSCPage';
